export const searchPredicate = (
  text: string,
  criteria?: null | string
): boolean => {
  if (!criteria) {
    return true;
  }

  const keyWords = criteria
    .split(" ")
    .map((word) => word.trim())
    .filter(Boolean);

  const result = keyWords.every((word) =>
    text.toLowerCase().includes(word.toLowerCase())
  );

  return result;
};
